class DrawerContent extends HTMLElement {
	constructor() {
		super();
		this.activeClass = 'drawer--open';
		this.addListeners();
		this.elements = {
			drawerClose: this.querySelector('[data-drawer-close]'),
			checkoutButton: this.querySelector('savedby-checkout-plus'),
		};
		this.checkFocusBind = this.checkFocus.bind(this);
	}
	addListeners() {
		this.addEventListener('click', (event) => {
			if (event.target.classList.contains('drawer')) {
				this.close();
			}
		});
		document.querySelectorAll('[data-drawer-close]').forEach((button) => {
			if (button.dataset.drawerClose !== this.id) {
				return;
			}
			button.addEventListener('click', this.close.bind(this));
		});
		document.querySelectorAll('[data-drawer-open]').forEach((button) => {
			if (button.dataset.drawerOpen !== this.id) {
				return;
			}
			button.addEventListener('click', this.open.bind(this));
		});
	}
	checkFocus(event) {
		const drawerDescendents = this.querySelectorAll('savedby-checkout-plus, a, button, input:not([type="hidden"]');
		const drawerContainerFirstChild = drawerDescendents[0];
		const drawerContainerLastChild = drawerDescendents[drawerDescendents.length - 1];

		if (!this.contains(document.activeElement) && event.relatedTarget == drawerContainerFirstChild) {
			drawerContainerFirstChild.focus();
		} else if (!this.contains(document.activeElement) && event.relatedTarget == drawerContainerLastChild) {
			drawerContainerFirstChild.focus();
		}
	}
	close() {
		this.classList.remove(this.activeClass);
		document.body.classList.remove('overflow--hidden');
		document.body.style.removeProperty('padding-right');
		window.removeEventListener('focusin', this.checkFocusBind);
		const openButton = document.querySelector(`[data-drawer-open=${this.id}]`);
		this.addEventListener(
			'transitionend',
			(e) => {
				e.stopPropagation();
				openButton.focus();
			},
			{ once: true }
		);
	}
	open(event) {
		const { drawerClose } = this.elements;
		if (event) {
			event.preventDefault();
		}
		this.classList.add(this.activeClass);
		document.body.style.paddingRight = window.innerWidth - document.body.clientWidth + 'px';
		document.body.classList.add('overflow--hidden');
		this.addEventListener(
			'transitionend',
			(e) => {
				e.stopPropagation();
				drawerClose.focus();
			},
			{ once: true }
		);

		window.addEventListener('focusin', this.checkFocusBind);
	}
}
if (!customElements.get('drawer-content')) {
	customElements.define('drawer-content', DrawerContent);
}
